var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCursorGrab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_26_47623)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.82881 3.15757C10.0888 2.20235 10.9624 1.5 12 1.5C13.0376 1.5 13.9112 2.20235 14.1712 3.15757C14.4277 3.05589 14.7073 3 15 3C16.2426 3 17.25 4.00736 17.25 5.25V6.12803C17.4846 6.04512 17.737 6 18 6C19.2426 6 20.25 7.00736 20.25 8.25V14.5083C20.25 15.944 19.8753 17.3549 19.163 18.6014L17.799 20.9884C17.2649 21.9231 16.2708 22.5 15.1943 22.5H9.40789C8.43904 22.5 7.52982 22.0321 6.96669 21.2437L4.7279 18.1094C4.0919 17.219 3.75 16.1521 3.75 15.0579V10.5C3.75 9.25736 4.75736 8.25 6 8.25C6.26298 8.25 6.51542 8.29512 6.75 8.37803V5.25C6.75 4.00736 7.75736 3 9 3C9.29269 3 9.57232 3.05589 9.82881 3.15757Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.82881 3.15757C10.0888 2.20235 10.9624 1.5 12 1.5C13.0376 1.5 13.9112 2.20235 14.1712 3.15757C14.4277 3.05589 14.7073 3 15 3C16.2426 3 17.25 4.00736 17.25 5.25V6.12803C17.4846 6.04512 17.737 6 18 6C19.2426 6 20.25 7.00736 20.25 8.25V14.5083C20.25 15.944 19.8753 17.3549 19.163 18.6014L17.799 20.9884C17.2649 21.9231 16.2708 22.5 15.1943 22.5H9.40789C8.43904 22.5 7.52982 22.0321 6.96669 21.2437L4.7279 18.1094C4.0919 17.219 3.75 16.1521 3.75 15.0579V10.5C3.75 9.25736 4.75736 8.25 6 8.25C6.26298 8.25 6.51542 8.29512 6.75 8.37803V5.25C6.75 4.00736 7.75736 3 9 3C9.29269 3 9.57232 3.05589 9.82881 3.15757ZM11.25 10.5C11.25 10.9142 10.9142 11.25 10.5 11.25C10.0858 11.25 9.75 10.9142 9.75 10.5V5.25C9.75 4.83579 9.41421 4.5 9 4.5C8.58579 4.5 8.25 4.83579 8.25 5.25V13.5C8.25 13.9142 7.91421 14.25 7.5 14.25C7.08579 14.25 6.75 13.9142 6.75 13.5V10.5C6.75 10.0858 6.41421 9.75 6 9.75C5.58579 9.75 5.25 10.0858 5.25 10.5V15.0579C5.25 15.8395 5.49421 16.6015 5.9485 17.2376L8.18729 20.3719C8.46886 20.7661 8.92346 21 9.40789 21H15.1943C15.7326 21 16.2296 20.7116 16.4966 20.2442L17.8606 17.8572C18.4434 16.8373 18.75 15.6829 18.75 14.5083V8.25C18.75 7.83579 18.4142 7.5 18 7.5C17.5858 7.5 17.25 7.83579 17.25 8.25V11.25C17.25 11.6642 16.9142 12 16.5 12C16.0858 12 15.75 11.6642 15.75 11.25V5.25C15.75 4.83579 15.4142 4.5 15 4.5C14.5858 4.5 14.25 4.83579 14.25 5.25V10.5C14.25 10.9142 13.9142 11.25 13.5 11.25C13.0858 11.25 12.75 10.9142 12.75 10.5V3.75C12.75 3.33579 12.4142 3 12 3C11.5858 3 11.25 3.33579 11.25 3.75V10.5Z",
    fill: "#12131A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_26_47623",
    x: 0.75,
    y: 0,
    width: 22.5,
    height: 27,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.0745098 0 0 0 0 0.101961 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_26_47623"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_26_47623",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCursorGrab);
export default __webpack_public_path__ + "static/media/cursorGrab.e00e43e06e5ac9080d02db0e64dde4b5.svg";
export { ForwardRef as ReactComponent };